<template>
  <div class="flex items-center justify-between py-4 px-2">
    <!-- Informação de Páginas -->
    <div class="text-sm text-[#4A4453]">
      {{ currentPage }}
    </div>

    <!-- Navegação -->
    <div class="flex items-center gap-2">
      <!-- Botão Anterior -->
      <button
        @click="onPageChange(currentPage - 1)"
        :disabled="currentPage === 1"
        class="p-2 rounded-lg text-[#4A4453] disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors"
      >
        <span class="material-icons">chevron_left</span>
      </button>

      <!-- Números das Páginas -->
      <div class="flex items-center gap-1">
        <template v-for="pageNumber in displayedPages">
          <!-- Reticências -->
          <span
            v-if="pageNumber === '...'"
            :key="'ellipsis-' + pageNumber"
            class="px-2 text-[#4A4453]"
            >...</span
          >

          <!-- Botão de Página -->
          <button
            v-else
            :key="pageNumber"
            @click="onPageChange(pageNumber)"
            :class="[
              'min-w-[32px] h-8 rounded-lg text-sm font-medium transition-colors',
              currentPage === pageNumber
                ? 'bg-[#FF5722] text-white'
                : 'text-[#4A4453] hover:bg-gray-100'
            ]"
          >
            {{ pageNumber }}
          </button>
        </template>
      </div>

      <!-- Botão Próximo -->
      <button
        @click="onPageChange(currentPage + 1)"
        :disabled="currentPage === totalPages"
        class="p-2 rounded-lg text-[#4A4453] disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors"
      >
        <span class="material-icons">chevron_right</span>
      </button>
    </div>
  </div>
</template>

<script lang="js">
export default {
  props: {
    currentPage: {
      type: Number,
      required: true
    },
    totalPages: {
      type: Number,
      required: true
    }
  },

  methods: {
    onPageChange(page) {
      this.$emit('update:page', page);
    }
  },

  computed: {
    displayedPages() {
      const pages = [];
      const maxVisiblePages = 7;

      if (this.totalPages <= maxVisiblePages) {
        return Array.from({ length: this.totalPages }, (_, i) => i + 1);
      }

      pages.push(1);

      if (this.currentPage > 3) {
        pages.push('...');
      }

      for (let i = Math.max(2, this.currentPage - 1); i <= Math.min(this.totalPages - 1, this.currentPage + 1); i++) {
        pages.push(i);
      }

      if (this.currentPage < this.totalPages - 2) {
        pages.push('...');
      }

      if (this.totalPages > 1) {
        pages.push(this.totalPages);
      }

      return pages;
    }
  }
}
</script>
